module.exports = __webpack_public_path__ + "static/classhook-clipview-before-745bd5f7c5ec4799837fefe744fbef66.jpg";